// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/singleProduct';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  home,
  aboutUs,
  singleProduct,
});

window.abc = function () {

  let swiper;
  window.globals = {};
  const body = document.getElementsByTagName("body")[0];
  const lightboxImages = document.querySelectorAll("[lightbox-toggle] img");
  const lightboxImagesComments = document.querySelectorAll("[lightbox-toggleComments] img");
  const initLightbox = lightboxImages.length > 0;
  const initLightboxComments = lightboxImagesComments.length > 0;
  const destroySwiper = (swiper, timeout) => {
    setTimeout(() => {
      swiper && swiper.destroy();
    }, timeout);
  };

  const createLightboxSkeleton = () => {
    // Create skeleton for lightbox
    const lightbox = document.createElement("div");
    const lightboxContainer = document.createElement("div");
    const lightboxClose = document.createElement("div");
    const swiperContainer = document.createElement("div");
    const swiperWrapper = document.createElement("div");
    const swiperBtnNext = document.createElement("div");
    const swiperBtnPrev = document.createElement("div");
    const swiperPagination = document.createElement("div");

    // Add classes
    lightbox.classList.add("c-lightbox");
    lightboxContainer.classList.add("c-lightbox__container");
    lightboxClose.classList.add("c-lightbox__close");
    lightboxClose.setAttribute("tabindex", "0");
    lightboxClose.innerHTML = "x";
    swiperContainer.classList.add("swiper-container");
    swiperWrapper.classList.add("swiper-wrapper");
    swiperBtnNext.classList.add("swiper-button-next");
    swiperBtnPrev.classList.add("swiper-button-prev");
    swiperPagination.classList.add("swiper-pagination");

    // Append created divs
    lightboxContainer.appendChild(lightboxClose);
    swiperContainer.appendChild(swiperWrapper);
    swiperContainer.appendChild(swiperBtnNext);
    swiperContainer.appendChild(swiperBtnPrev);
    swiperContainer.appendChild(swiperPagination);
    lightboxContainer.appendChild(swiperContainer);
    lightbox.appendChild(lightboxContainer);
    body.appendChild(lightbox);

    // Set variables to reference the lightbox
    globals.lightboxRef = document.querySelector(".c-lightbox");
    globals.swiperWrapperRef = document.querySelector(
      ".c-lightbox .swiper-wrapper"
    );
  };

  if (initLightbox || initLightboxComments) {
    if (!document.body.classList.contains('c-lightbox')) {
      createLightboxSkeleton();
    }
  }

  if (initLightbox) {
    // The rest of the code will go here
    lightboxImages.forEach(function (el, index) {
      // Add click function to lightbox images
      el.addEventListener("click", imageClick, false);

      function imageClick() {
        // Clear swiper before trying to add to it
        globals.swiperWrapperRef.innerHTML = "";

        // Loop through images with lightbox data attr
        // Create html for lightbox carousel
        lightboxImages.forEach(function (img) {
          console.log(index);
          // Create clone of current image in loop
          const image = img.cloneNode(true);
          // Create divs
          const slide = document.createElement("div");
          const imageContainer = document.createElement("div");
          // Add classes
          slide.classList.add("swiper-slide");
          imageContainer.classList.add("c-lightbox__image");
          // Append images to the slides, then slides to swiper wrapper
          imageContainer.appendChild(image);
          slide.appendChild(imageContainer);
          globals.swiperWrapperRef.appendChild(slide);
        });

        // Init Swiper
        swiper = new Swiper(".c-lightbox .swiper-container", {
          initialSlide: index,
          loop: true,
          slidesPerView: 1,
          speed: 750,
          spaceBetween: 16,
          watchOverflow: true,
          pagination: {
            el: ".swiper-pagination",
            type: "fraction"
          },
          zoom: false,
          fadeEffect: {
            crossFade: false
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          mousewheel: {
            sensitivity: 1,
            forceToAxis: true,
            invert: true
          }
        });

        // Add the class to open the lightbox
        // Add overflow hidden to the body to prevent scrolling
        globals.lightboxRef.classList.add("open");
        body.classList.add("overflowHidden");
      }
    });
  }

  if (initLightboxComments) {
    // The rest of the code will go here
    lightboxImagesComments.forEach(function (el, index) {
      // Add click function to lightbox images
      el.addEventListener("click", imageClick, false);

      function imageClick() {
        // Clear swiper before trying to add to it
        globals.swiperWrapperRef.innerHTML = "";

        // Loop through images with lightbox data attr
        // Create html for lightbox carousel
        lightboxImagesComments.forEach(function (img) {
          console.log(index);
          // Create clone of current image in loop
          const image = img.cloneNode(true);
          // Create divs
          const slide = document.createElement("div");
          const imageContainer = document.createElement("div");
          // Add classes
          slide.classList.add("swiper-slide");
          imageContainer.classList.add("c-lightbox__image");
          // Append images to the slides, then slides to swiper wrapper
          imageContainer.appendChild(image);
          slide.appendChild(imageContainer);
          globals.swiperWrapperRef.appendChild(slide);
        });

        // Init Swiper
        swiper = new Swiper(".c-lightbox .swiper-container", {
          initialSlide: index,
          loop: true,
          slidesPerView: 1,
          speed: 750,
          spaceBetween: 16,
          watchOverflow: true,
          pagination: {
            el: ".swiper-pagination",
            type: "fraction"
          },
          zoom: false,
          fadeEffect: {
            crossFade: false
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          mousewheel: {
            sensitivity: 1,
            forceToAxis: true,
            invert: true
          }
        });

        // Add the class to open the lightbox
        // Add overflow hidden to the body to prevent scrolling
        globals.lightboxRef.classList.add("open");
        body.classList.add("overflowHidden");
      }
    });
  }

  // Close lightbox on click
  document.addEventListener(
    "click",
    ({ target }) => {
      if (target.matches(".c-lightbox__close")) {
        destroySwiper(swiper, 250);
        globals.lightboxRef.classList.remove("open");
        body.classList.remove("overflowHidden");
      }
    },
    false
  );

  // Close lightbox on escape key press
  document.addEventListener("keydown", ({ key }) => {
    if (key === "Escape") {
      destroySwiper(swiper, 250);
      globals.lightboxRef.classList.remove("open");
      body.classList.remove("overflowHidden");
    }
  });
}
setTimeout(window.parent.abc, 10);
// Load Events
jQuery(document).ready(() => routes.loadEvents());

let backToTopBtn = document.getElementById('btn-back-to-top');
var lastScrollTop = 0;

if (backToTopBtn != null) {
  window.addEventListener('scroll', function () {
    var st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollTop || st === 0) {
      backToTopBtn.classList.remove('show');
    } else if (st < lastScrollTop) {
      backToTopBtn.classList.add('show');
    }

    lastScrollTop = st <= 0 ? 0 : st;
  });

  backToTopBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  let footer = document.querySelector('footer');

  if ('IntersectionObserver' in window && footer) {
    let observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          backToTopBtn.classList.add('above-footer');
        } else {
          backToTopBtn.classList.remove('above-footer');
        }
      });
    }, {
      root: null,
      threshold: 0,
    });

    observer.observe(footer);
  }
}

const showMobileFiltersPopScrollUp = () => {
  let lastScrollTop = 0;
  let accumulatedScrollUp = 0;
  let accumulatedScrollDown = 0;
  const scrollThreshold = 150;

  // Function to check if the device is a phone
  const isPhone = () => {
    const maxWidth = 1024;
    const maxHeight = 600;
    return window.innerWidth <= maxWidth && window.innerHeight <= maxHeight;
  };

  const updateElementVisibility = () => {
    const mobileFilterPop = $('.mobile-filter-pop');
    const isLandscape = window.matchMedia("(orientation: landscape)").matches;
    if (isPhone() && isLandscape) {
      mobileFilterPop.removeClass('fixed');
    } else {
      if (accumulatedScrollUp >= scrollThreshold) {
        if ($(window).scrollTop() > 200) {
          mobileFilterPop.addClass('fixed');
        } else {
          mobileFilterPop.removeClass('fixed');
        }
      }
      if (accumulatedScrollDown >= scrollThreshold) {
        mobileFilterPop.removeClass('fixed');
      }
    }
  };

  $(window).on('scroll', function() {
    const scrollPosition = $(this).scrollTop();

    if (scrollPosition < lastScrollTop) {
      accumulatedScrollUp += (lastScrollTop - scrollPosition);
      accumulatedScrollDown = 0;
    } else {
      accumulatedScrollDown += (scrollPosition - lastScrollTop);
      accumulatedScrollUp = 0;
    }

    updateElementVisibility();

    lastScrollTop = scrollPosition;
  });

  // Function to handle window resize and remove 'fixed' class on phones
  const handleResize = () => {
    const mobileFilterPop = $('.mobile-filter-pop');
    if (isPhone()) {
      mobileFilterPop.removeClass('fixed');
    }
  };

  $(window).on('resize', handleResize); // Attach the resize event listener
  $(window).on('orientationchange', updateElementVisibility); // Update on orientation change
};

showMobileFiltersPopScrollUp();

window.addEventListener('load', function() {
  const signInUrl = window.location.protocol + "//" + window.location.hostname + '/sign-in';
  const currentPage = window.location.href;
  
  if (currentPage.includes(signInUrl)) {
    sessionStorage.setItem('previousPage', currentPage);
  }

  const getCurrentUrl = new URL(window.location.href);
  const isHomePage = getCurrentUrl.pathname == '/';

  if (isHomePage) {
    sessionStorage.removeItem('previousPage');
  }

  const backButton = document.getElementById("backBtn");
  backButton && backButton.addEventListener("click", customHistoryBack);
});

// Custom history back on browser click back.
if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
  if (window.location.pathname === '/certified-markets/'
  ) {
    customHistoryBack();
  }
}

// Custom history back on Backspace.
window.addEventListener('keydown', function (event) {
  if ((event.key === 'Backspace' || event.keyCode === 8) && !isTypingInInput()) {
      customHistoryBack();
  }
});

function isTypingInInput() {
  const activeElement = document.activeElement;
  return activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.tagName === 'SELECT';
}

function customHistoryBack() {
  const signInUrl = window.location.protocol + "//" + window.location.hostname + '/sign-in';
  const previousPage = sessionStorage.getItem('previousPage');
  const certificatesPage = window.location.protocol + "//" + window.location.hostname + '/certified-markets';

  if (previousPage) {
    if (previousPage.includes(signInUrl)) {
      window.location.href = window.location.protocol + "//" + window.location.hostname;
    }

    if (previousPage.includes(certificatesPage)) {
      window.location.href = previousPage;
      return;
    }
  } else {
    history.back();
  }
}

if (document.body.classList.contains('client-login')) {
  const inputs = document.querySelectorAll('input, textarea');

  function setKeyboardOffset() {
      const keyboardOffset = 300; // Adjust based on the typical keyboard height
      document.documentElement.style.setProperty('--keyboard-offset', `${keyboardOffset}px`);
  }

  function resetBody() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
      document.documentElement.style.setProperty('--keyboard-offset', '0px');
  }

  inputs.forEach(input => {
      input.addEventListener('focus', () => {
          document.body.dataset.scrollY = window.scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${window.scrollY}px`;
          document.body.style.overflow = 'hidden';
          document.body.style.width = '100%';
          setKeyboardOffset();
          document.body.classList.add('keyboard-open');
      });

      input.addEventListener('blur', () => {
          resetBody();
          document.body.classList.remove('keyboard-open');
          window.scrollTo(0, 0);
      });
  });

  window.addEventListener('scroll', () => {
      if (document.body.classList.contains('keyboard-open')) {
          document.body.dataset.scrollY = window.scrollY;
      }
  });

  window.addEventListener('resize', () => {
      if (!document.activeElement || !['input', 'textarea'].includes(document.activeElement.tagName.toLowerCase())) {
          resetBody();
      }
  });
}
var pluginPath = '/wp-content/plugins/resize-thumbs-plugin/js/';
var currentScript = null; // Track the currently loaded script

// Function to dynamically load a script and unload the previous one
function loadScript(scriptName, callback) {
    // Remove the previously loaded script if it exists
    if (currentScript && currentScript.parentNode) {
        currentScript.parentNode.removeChild(currentScript);
        currentScript = null;
    }

    // Create a new script element
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = pluginPath + scriptName;

    // Set up a callback when the script is loaded
    script.onload = function() {
        if (callback) callback();
    };

    // Append the script to the head of the document
    document.head.appendChild(script);

    // Store a reference to the new script
    currentScript = script;
}
const formatContainer = document.getElementById('options-container');
const popupTitle = document.getElementsByClassName('popupTitle')[0];

// Function to show or hide the format container based on the button id
function toggleFormatContainer(buttonId) {
  const uploadButton = document.getElementById(buttonId);

  // Remove any previous format containers if they exist
  const existingFormatContainers = document.querySelectorAll('#options-container');
  if (existingFormatContainers.length > 1) {
    // If there are multiple format containers, remove the extras
    formatContainer.remove();
  }
  const generatedTitle = document.querySelector('.resultHeader > h4.subtitle');
  if (window.location.href.includes('resources')) {
    if (buttonId === 'upload-single-btn') {
        formatContainer.style.display = 'none'; // Hide the format container
        popupTitle.innerText = 'Download thumbnail';
        uploadButton.classList.remove('generate-multi-thumbs');
        uploadButton.innerText = 'Generate';
        generatedTitle.textContent = `Generated thumbnail`;
        console.log('Format container hidden because upload-single-btn was clicked');
        
        //Fix default behavior
        const singleThumbGenerateButton = document.getElementById('upload-single-btn');
        if (singleThumbGenerateButton) {
            singleThumbGenerateButton.disabled = true; // Disable upload button
        }

    } else if (buttonId === 'upload-btn') {
      if (formatContainer) {
        formatContainer.style.display = 'block'; // Show the format container
        popupTitle.innerText = 'Download selected thumbnails';
        generatedTitle.textContent = `Generated thumbnails`;

        // Disable radio buttons on initial load
        const radioButtons = formatContainer.querySelectorAll('input[type="radio"]');
        radioButtons.forEach(button => {
            button.disabled = true; // Disable each radio button
        });

      }
      if(uploadButton) { 
        uploadButton.innerText = 'Download';
      }
      console.log('Format container shown because upload-btn was clicked');
    }
  } else {
    if (formatContainer) {
      formatContainer.style.display = 'none'; // Hide the format container on other pages
      popupTitle.innerText = 'Download thumbnail';
      generatedTitle.textContent = `Generated thumbnail`;
    }
  }
}

      // Get the checkbox element by its ID
      var checkbox = document.getElementById("thumbs");
      var isChecked = false;

      // Event listener to update the isChecked variable on checkbox state change
      if(checkbox) {
        checkbox.addEventListener('change', function() {
          isChecked = checkbox.checked;
          applyLogicBasedOnPage(); // Re-apply logic whenever the checkbox state changes
        });
      }
    
// Function to determine which logic to apply
function applyLogicBasedOnPage() {
  console.log('Applying logic based on page...');
  var path = window.location.pathname;
  const generateButton = document.getElementById('upload-btn') || document.getElementById('upload-single-btn');
  const thumbsCheckbox = document.getElementById('thumbs'); // The checkbox element for thumbnails
  const selectAllCheckbox = document.getElementById('test'); // The "Select All" checkbox element
  var selectedThumbs = document.querySelectorAll('.single-material-row.selected.generated-thumb');
  var selectedFiles = document.querySelectorAll('.single-material-row.selected:not(.generated-thumb)');
  const uploadBtn = document.getElementById('upload-btn');
  const uploadBtnSingle = document.getElementById('upload-single-btn');
  const customFileOverlayThumbs = document.querySelector('.custom-file-overlay-thumbs');
  // Initialize the state variable for "Select All"
  let isSelectAllChecked = selectAllCheckbox ? selectAllCheckbox.checked : false;

  // Only add event listener if the "Select All" checkbox exists
  if (selectAllCheckbox) {
    selectAllCheckbox.addEventListener('change', function () {
      isSelectAllChecked = selectAllCheckbox.checked; // Update the state variable
      if (isSelectAllChecked) {
        // Case: Checkbox is checked OR multiple items are selected
        loadScript('resize-multiple-thumbs-script.js', function () {
          console.log('Loaded resize-multiple-thumbs-script.js for multiple thumbs');
          if (uploadBtnSingle) {
            uploadBtnSingle.id = 'upload-btn'; // Change button ID for multiple uploads
            uploadBtnSingle.innerText = 'Download'; // Change button text to "Download"
          }
          generateButton.classList.add('generate-multi-thumbs'); // Add class for multiple thumbs
          toggleFormatContainer('upload-btn'); // Toggle format container visibility
        });
      }
    });
  }

  customFileOverlayThumbs.addEventListener('click', function () {
    const uploadBtnSingle = document.getElementById('upload-single-btn');
    loadScript('resize-multiple-thumbs-script.js', function () {
      console.log('Loaded resize-multiple-thumbs-script.js for multiple thumbs');
      if(uploadBtnSingle) {

        uploadBtnSingle.id = 'upload-btn'; // Change button ID for multiple uploads
        uploadBtnSingle.innerText = 'Download'; // Change button text to "Download"
      }
      generateButton.classList.add('generate-multi-thumbs'); // Add class for multiple thumbs
      toggleFormatContainer('upload-btn'); // Toggle format container visibility
    });
  });

  // Define the function to load a script dynamically
  function loadScript(scriptName, callback) {
    const baseURL = `${window.location.origin}/wp-content/plugins/resize-thumbs-plugin/js/`;
    const version = new Date().getTime(); // Get the current timestamp for versioning
    const scriptUrl = baseURL + scriptName + '?ver=' + version; // Construct full URL with version

    // Check for existing script and remove it if found
    document.querySelectorAll(`script[src*="${scriptName}"]`).forEach(script => script.remove());

    // Create a new script element and append it to the document
    const scriptElement = document.createElement('script');
    scriptElement.src = scriptUrl; // Set the source to the versioned URL
    scriptElement.onload = callback; // Execute the callback function once the script loads
    document.body.appendChild(scriptElement); // Append the script to the body
  }

  // Page-specific logic based on URL path
  if (path.includes('/resources')) {
    // Remove the 'generate-multi-thumbs' class by default
    generateButton.classList.remove('generate-multi-thumbs');

    // Logic to change the ID based on the number of selected thumbs and files
    if (selectedThumbs.length === 1 && selectedFiles.length === 0) {
      // Case: Only one thumbnail selected and no other files
      loadScript('resize-thumbs-script.js', function () {
        console.log('Loaded resize-thumbs-script.js for single thumb');
        if (uploadBtn) {
          uploadBtn.id = 'upload-single-btn'; // Change button ID for single upload
          uploadBtn.classList.remove('generate-multi-thumbs');
          uploadBtn.innerText = 'Generate'; // Change button text to "Generate"
        }
        toggleFormatContainer('upload-single-btn'); // Toggle format container visibility
      });
    } else if ((thumbsCheckbox.checked || isSelectAllChecked) || selectedThumbs.length > 1 || (selectedThumbs.length >= 1 && selectedFiles.length > 0)) {
      // Case: Checkbox is checked OR multiple items are selected
      loadScript('resize-multiple-thumbs-script.js', function () {
        console.log('Loaded resize-multiple-thumbs-script.js for multiple thumbs');
        if (uploadBtnSingle) {
          uploadBtnSingle.id = 'upload-btn'; // Change button ID for multiple uploads
          uploadBtnSingle.innerText = 'Download'; // Change button text to "Download"
        }
        generateButton.classList.add('generate-multi-thumbs'); // Add class for multiple thumbs
        toggleFormatContainer('upload-btn'); // Toggle format container visibility
      });
    } else {
      // Fallback: Load default script
      loadScript('resize-thumbs-script.js', function () {
        console.log('Loaded default resize-thumbs-script.js');
        if (uploadBtnSingle) {
          uploadBtnSingle.id = 'upload-btn'; // Change button ID for fallback
          uploadBtnSingle.innerText = 'Download'; // Change button text to "Download"
        }
      });
    }
  } else {
    // For pages that don't match "/resources"
    toggleFormatContainer('upload-single-btn');
    if (formatContainer) {
      formatContainer.style.display = 'none'; // Hide the format container on other pages
    }
  }
}


// Convert the HTMLCollection to an array and loop through it
Array.from(document.getElementsByClassName('resizeThumbnailBtn')).forEach(button => {
  button.addEventListener('click', function() {
      var selectedThumbs = document.querySelectorAll('.single-material-row.selected.generated-thumb');
      const uploadBtn = document.getElementById('upload-single-btn') || document.getElementById('upload-btn');

      if (selectedThumbs.length > 0) {
          // Proceed to load the single resize script
          loadScript('resize-thumbs-script.js', function() {
              if (uploadBtn) {
                  uploadBtn.id = 'upload-single-btn'; // Ensure button is set to single
                  uploadBtn.classList.remove('generate-multi-thumbs');
              }
              toggleFormatContainer('upload-single-btn');
          });
      }
  });
});



// Initial call to apply logic when the page loads
applyLogicBasedOnPage();

// Event listener function for checkbox changes
function onCheckboxChange() {
  console.log('Checkbox change detected...');
  
  // Apply logic whenever a checkbox is checked or unchecked
  applyLogicBasedOnPage();
}

// Add event listeners to all checkboxes within the `.single-material-row` elements
function attachCheckboxListeners() {
  var checkboxes = document.querySelectorAll('.single-material-row input[type="checkbox"]');
  checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', onCheckboxChange);
  });
}

// Initialize the script by attaching listeners to checkboxes
attachCheckboxListeners();

function isRestrictedPage() {
  // Get the <body> element
  const body = document.body;

  // Check if the <body> element contains specific classes
  const restrictedClasses = ['client-login', 'client-forgot-password', 'client-new-activate'];
  
  return restrictedClasses.some(cls => body.classList.contains(cls));
}

// Initialize the script only on restricted pages
if (isRestrictedPage()) {

  // Apply CSS styles to prevent scrolling
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  document.documentElement.style.height = '100%';
  document.body.style.height = '100%';
  document.documentElement.style.margin = '0';
  document.body.style.margin = '0';

  // Prevent scrolling
  document.addEventListener('touchmove', function(event) {
    event.preventDefault();
  }, { passive: false });

  // Prevent scrolling with arrow keys and space bar
  window.addEventListener('keydown', function(event) {
    if (event.keyCode === 32 || (event.keyCode >= 37 && event.keyCode <= 40)) {
      event.preventDefault();
    }
  });

  // Prevent double-tap zoom
  let lastTouchEnd = 0;
  document.addEventListener('touchend', function(event) {
    const now = new Date().getTime();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);
}

function getDeviceType() {
  const width = window.innerWidth;
  const height = window.innerHeight;

  const isiPad = navigator.userAgent.match(/iPad/i) || 
                 (navigator.userAgent.match(/Macintosh/i) && 'ontouchend' in document);

  if (isiPad) {
      return 'tablet'; // Always treat iPad as a tablet
  }

  // Consider devices based on both width and height
  if (width >= 1024 && height >= 620) {
      return 'desktop'; // Desktop or small laptop
  } else if (width >= 768 && width < 1024) {
      return 'tablet'; // Larger tablets
  } else if (width >= 600 && width < 768) {
      return 'small-tablet'; // Smaller tablets, 7-inch devices
  } else {
      return 'mobile'; // Phones
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const deviceType = getDeviceType();
  const resizeButtons = document.querySelectorAll('.resize-plugin');
  

  if (deviceType === 'desktop') {
      resizeButtons.forEach(function(button) {
          button.style.display = 'flex';
      });
  } else {
      resizeButtons.forEach(function(button) {
          button.style.display = 'none';
      });
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js